export default "__VITE_ASSET__a9qlwbeH__"